<template>
  <v-card>
    <v-card-title>
      <v-icon>credit_card</v-icon> Billing information
      <v-spacer></v-spacer>
      <v-btn small color='primary' class='hidden-ios-true'
        :href='billingUrl' target='_blank' >Make a payment</v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <!-- <div class='pa-3' v-if='freeTrial.isActive' >Free trial expires: {{dateformat(freeTrial.expires)}} ({{freeTrialDays}} days time)</div> -->
      <v-list two-line class='elevation-4' v-if='nextPayment' >
        <v-subheader>Your next payment:</v-subheader>
        <v-list-tile dense >
          <v-list-tile-content>
            <v-list-tile-title>{{dateformat(nextPayment.scheduled_date)}}
            </v-list-tile-title>
            <v-list-tile-sub-title>Scheduled date.</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>{{formatCurrency(nextPayment.currency, nextPayment.amount)}}
          </v-list-tile-action>
        </v-list-tile>
      </v-list>

      <v-subheader>Invoices / Payments</v-subheader>
      <vuex-loader request-id='requests.transactions' ></vuex-loader>
      <v-list two-line  class='elevation-4'
        v-if='transactions && transactions.length > 0' >
        <v-list-tile v-for='transaction in transactions' :key='transaction.id' v-if='transaction' >
          <v-list-tile-action>
            <v-icon v-if='transaction.result_code === "000.000.000"' color='success' >check</v-icon>
            <v-icon v-else color='error' >warning</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{dateformat(transaction.created_date)}}
            </v-list-tile-title>
            <v-list-tile-sub-title>#{{transaction.transaction_id}}. {{transaction.result_description}}.</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action v-if='transaction.result_code === "000.000.000"' >
            <v-btn
              :href='transactoinUrl(transaction.id, transaction.transaction_id)'
              target='_blank' icon ><v-icon>open_in_new</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-card v-else >
        <v-card-text v-if='!transactionRequest.loading' >No invoices found</v-card-text></v-card>
      <v-divider></v-divider>
      <!-- <v-subheader>Danger Zone</v-subheader>
      <v-btn color='error'small >Cancel my account</v-btn> -->
    </v-card-text>

    <v-card class='mt-5' >
      <v-card-title class='subtitle-1 overline' >
        Cancel account
      </v-card-title>
      <v-card-text>
        To cancel your account,
        please email support@appointmentguru.co with the subject: "Please cancel my account"
        from the email address associated with this account ({{me.email}}).

      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  name: 'BillingPage',
  mounted () {
    this.$subscriptionguru.resource('transaction').id(this.requests.transactions).list()
    let params = {ordering: 'scheduled_date', status: 'new'}
    this.$subscriptionguru.resource('scheduledpayment').id(this.requests.payments).list(params)
  },
  data () {
    return {
      requests: {
        transactions: 'transaction-list-req',
        payments: 'payments-upcoming-list-req'
      }
    }
  },
  methods: {
    transactoinUrl (id, tId) {
      return `https://subscriptionguru.appointmentguru.co/transaction/${id}/?key=${tId}`
    }
  },
  computed: {
    transactionRequest () {
      return this.$store.getters.getRequestById(this.requests.transactions, true)
    },
    upcomingPaymentsRequest () {
      return this.$store.getters.getRequestById(this.requests.payments, true)
    },
    transactions () {
      return this.getObjectPath(this.transactionRequest, 'result.data.results', [])
    },
    nextPayment () {
      let payments = this.getObjectPath(this.upcomingPaymentsRequest, 'result.data.results', [])
      if (payments.length > 0) {
        return payments[0]
      }
    },
    freeTrialDays () {
      return moment(this.freeTrial.expires).from()
    },
    freeTrial () {
      return {
        isActive: true,
        expires: moment().add(6, 'days')
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Billing.vue?3e4e79ae